import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/pro-regular-svg-icons';

interface EmptyStateProps {
  /** Heading — defaults to the "company has no roles" case. */
  title?: string;
  /** Supporting copy under the heading. */
  message?: string;
}

const EmptyState = ({
  title = 'No Roles Available',
  message = 'This company doesn’t have any roles to display.',
}: EmptyStateProps) => (
  <div
    className="flex flex-col items-center justify-center py-8 px-4 bg-neutral-50 rounded-lg text-center"
    data-testid="roles-empty-state"
  >
    <div className="flex flex-col items-center gap-3">
      <Icon icon={faShieldHalved} className="text-4xl text-neutral-400" />
      <div className="flex flex-col gap-1">
        <h4 className="text-sm font-medium text-neutral-900">{title}</h4>
        <p className="text-sm text-neutral-500">{message}</p>
      </div>
    </div>
  </div>
);

export default EmptyState;
